export default __webpack_public_path__ + "static/media/8d090cde74df4ec34ec6243bd826419c.e5c457af.png";